import React, {useEffect} from 'react';
import {Button, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '../../store';
import {AsyncTaskStatusType} from '../../shared/dtos';
import ErrorText from '../../components/ErrorText';
import CustomDialog from '../../components/CustomDialog';
import {removeFileFromTaskAction} from '../../api/task';
import {setRemoveFileFromTaskTaskStatus} from '../../features/task/taskSlice';

interface DeleteTaskFileDialogProps {
    handleClose: () => void;
    handleDelete: () => void;
    taskId: number;
    fileId: number;
    fileName: string;
}

export const DeleteTaskFileDialog: React.FC<DeleteTaskFileDialogProps> = ({
                                                                              handleClose,
                                                                              handleDelete,
                                                                              taskId,
                                                                              fileId,
                                                                              fileName,
                                                                          }) => {
    const removeFileTaskStatus = useSelector((state: AppState) => state.task.removeFileFromTaskTaskStatus);
    const dispatch: any = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(setRemoveFileFromTaskTaskStatus(null));
        };
    }, [dispatch]);

    const handleDeleteClick = async () => {
        try {
            const result = await dispatch(removeFileFromTaskAction({taskId, fileId}));
            if (result.type === 'contract/removeFileFromTask/fulfilled') {
                handleDelete();
                handleClose();
            }
        } catch (error) {
            console.error('Dosya silme işleminde bir hata oluştu:', error);
        }
    };

    return (
        <CustomDialog open={true} onClose={handleClose}>
            <DialogTitle>Dosyayı Sil ({fileName})</DialogTitle>
            <DialogContent>
                Bu dosyayı silmek istediğinizden emin misiniz?
                {removeFileTaskStatus?.type === AsyncTaskStatusType.Error &&
                    removeFileTaskStatus.errorMessage && (
                        <ErrorText type="form" message={removeFileTaskStatus.errorMessage}/>
                    )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>İptal</Button>
                <Button onClick={handleDeleteClick} color="error">
                    Sil
                </Button>
            </DialogActions>
        </CustomDialog>
    );
};
